export const CLEAR_ALL = state => {
  state.all = [];
  state.current = {};
};

export const SET_ALL = (state, payload) => {
  state.all = payload;
};

export const CREATE = (state, payload) => {
  state.all.push(payload);
};

export const SET_ITEM = (state, payload) => {
  state.current = payload;
};

export const UPDATE = (state, payload) => {
  let old = state.all.find(x => x._id === payload._id);
  if (old) state.all.splice(state.all.indexOf(old), 1);
  state.all.push(payload);
};

export const DELETE = (state, payload) => {
  state.all.splice(state.all.indexOf(payload), 1);
  state.current = {};
};
